import { tsv } from "@faire/slate/lib/tsv";
import { isNotUndefined } from "@faire/typescript";
import React from "react";

import { ButtonLoading } from "./ButtonLoading";
import { INativeProps, IButtonClickHandler } from "./types";

type IProps = {
  as?: React.ElementType;
  loading?: boolean;
  loadingLabel?: string;
  onClick?: IButtonClickHandler;
  disabled?: boolean;
  ref?: React.Ref<unknown>;
} & INativeProps;

export const ButtonBase = ({
  children,
  className,
  as: Component = "button",
  loading,
  loadingLabel,
  ...props
}: IProps) => {
  const buttonCls = buttonStyle.cls({ className, loading });

  return (
    <Component
      className={buttonCls}
      aria-disabled={loading || props.disabled}
      aria-busy={loading}
      aria-live={isNotUndefined(loading) ? "polite" : undefined}
      {...props}
    >
      {loading ? (
        <>
          <span className="invisible contents" aria-hidden="true">
            {children}
          </span>
          <ButtonLoading label={loadingLabel} />
        </>
      ) : (
        children
      )}
    </Component>
  );
};

const buttonStyle = tsv({
  vars: {
    color: "fso-btn-text-color",
    hoverColor: "fso-btn-hover-text-color",
    activeColor: "fso-btn-active-text-color",
    disabledColor: "fso-btn-disabled-text-color",
    iconColor: "fso-btn-icon-color",
    iconHoverColor: "fso-btn-hover-icon-color",
    iconActiveColor: "fso-btn-active-icon-color",
    iconDisabledColor: "fso-btn-disabled-icon-color",
    bgColor: "fso-btn-bg-color",
    hoverBgColor: "fso-btn-hover-bg-color",
    activeBgColor: "fso-btn-active-bg-color",
    disabledBgColor: "fso-btn-disabled-bg-color",
    height: "fso-btn-height",
    width: "fso-btn-width",
  },
  base: "fs-button interactive focusable",
  variants: {
    loading: {
      true: "cursor-wait",
    },
  },
});

export const buttonStyleVars = buttonStyle.vars;
